module.exports = __webpack_public_path__ + "img/kstdata.66f07e7e.png";